// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Terraform Article ──────────────────────────────────── */
.terraform-page {
  margin-top: 64px;
  padding: 60px 10%;
  background-color: var(--bg);
  min-height: calc(100vh - 64px);
}
@media (max-width: 768px) {
  .terraform-page {
    padding: 48px 5%;
  }
}

.article-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.825rem;
  font-weight: 600;
  color: var(--text-muted) !important;
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 5px 12px;
  margin-bottom: 32px;
  transition: border-color 0.2s, color 0.2s;
  text-decoration: none;
}
.article-back-btn:hover {
  border-color: var(--accent);
  color: var(--accent) !important;
}

.terraform-article {
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}
.terraform-article h1 {
  font-size: 1.9rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 8px;
  color: var(--text) !important;
  text-align: center;
}
.terraform-article h2 {
  font-size: 1.2rem;
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 12px;
  color: var(--text) !important;
  padding-left: 12px;
  border-left: 3px solid var(--accent);
}
.terraform-article p {
  color: var(--text-muted) !important;
  margin-bottom: 16px;
  font-size: 0.95rem;
}
.terraform-article ul {
  margin-left: 20px;
  margin-bottom: 16px;
}
.terraform-article ul li {
  color: var(--text-muted) !important;
  margin-bottom: 6px;
  font-size: 0.95rem;
}
.terraform-article pre {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 16px 18px;
  overflow-x: auto;
  margin: 20px 0;
}
.terraform-article pre code {
  color: var(--accent-2) !important;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  font-size: 0.85rem;
}
.terraform-article img {
  max-width: 100%;
  border-radius: 8px;
  border: 1px solid var(--border);
  margin: 20px auto;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/TerraformArticle.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,8BAAA;AACF;AACE;EANF;IAM8B,gBAAA;EAG5B;AACF;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mCAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AAIF;AAFE;EACE,2BAAA;EACA,+BAAA;AAIJ;;AAAA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAGF;AADE;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AAGJ;AAAE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oCAAA;AAEJ;AACE;EACE,mCAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAEE;EACE,iBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,mCAAA;EACA,kBAAA;EACA,kBAAA;AAAN;AAIE;EACE,0BAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAFJ;AAII;EACE,iCAAA;EACA,wDAAA;EACA,kBAAA;AAFN;AAME;EACE,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,iBAAA;EACA,cAAA;AAJJ","sourcesContent":["/* ─── Terraform Article ──────────────────────────────────── */\n\n.terraform-page {\n  margin-top: 64px;\n  padding: 60px 10%;\n  background-color: var(--bg);\n  min-height: calc(100vh - 64px);\n\n  @media (max-width: 768px) { padding: 48px 5%; }\n}\n\n.article-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.825rem;\n  font-weight: 600;\n  color: var(--text-muted) !important;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 5px 12px;\n  margin-bottom: 32px;\n  transition: border-color 0.2s, color 0.2s;\n  text-decoration: none;\n\n  &:hover {\n    border-color: var(--accent);\n    color: var(--accent) !important;\n  }\n}\n\n.terraform-article {\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.8;\n\n  h1 {\n    font-size: 1.9rem;\n    font-weight: 800;\n    letter-spacing: -0.5px;\n    margin-bottom: 8px;\n    color: var(--text) !important;\n    text-align: center;\n  }\n\n  h2 {\n    font-size: 1.2rem;\n    font-weight: 700;\n    margin-top: 40px;\n    margin-bottom: 12px;\n    color: var(--text) !important;\n    padding-left: 12px;\n    border-left: 3px solid var(--accent);\n  }\n\n  p {\n    color: var(--text-muted) !important;\n    margin-bottom: 16px;\n    font-size: 0.95rem;\n  }\n\n  ul {\n    margin-left: 20px;\n    margin-bottom: 16px;\n\n    li {\n      color: var(--text-muted) !important;\n      margin-bottom: 6px;\n      font-size: 0.95rem;\n    }\n  }\n\n  pre {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    padding: 16px 18px;\n    overflow-x: auto;\n    margin: 20px 0;\n\n    code {\n      color: var(--accent-2) !important;\n      font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n      font-size: 0.85rem;\n    }\n  }\n\n  img {\n    max-width: 100%;\n    border-radius: 8px;\n    border: 1px solid var(--border);\n    margin: 20px auto;\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
